import React from 'react';
import {withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import LinkDuo from '../LinkDuo/LinkDuo';
import { connect } from 'react-redux';
import { actionCreators as dbCreators } from '../../afw/store/db';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import './BreadCrumb.css';

const StyledBreadcrumb = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: 24,
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: theme.palette.grey[400],
    },
    zIndex: 1
  },
}))(Chip); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

const styles = theme => ({
  root: {
    background: '#333',
    overflow: 'hidden'
  },
  nav:{

  },
  avatar: {
    background: 'none',
  },
  breadcrumbs:{
    margin: '0',
    display: 'inline-flex',
    flexWrap: 'wrap',
    padding: '5px 16px',
    alignItems: 'center',
    listStyle: 'none',
    position: 'relative',
    background: '#FFF',
  },
  seperator:{
    display: 'flex',
    marginLeft: '8px',
    userSelect: 'none',
    marginRight: '8px',
    zIndex: 1
  },
  breadcrumbsli:{
    display: 'list-item'
  },
  filler: {
    width: '80px', background: '#DDDDDD', height: '15px', margin: '0 10px', borderRadius: '14px', zIndex: 1
  }
});

class BreadCrumbs extends React.PureComponent {
  state = {data: [], loading: true, propData: []}
  handleLoadData= async ()=>{
    const {db, navData} = this.props;
    let data = [];
    if(navData.length > 0){
      const filter = navData.reduce((r,a)=>r.concat([['page_name', '=', a]], 'or'), []);
      filter.pop();
      const tempData = await db.t_page.load({filter, select: ['page_title', 'url_link', 'page_name']});
      //Resort fetched Data to specific order given
      navData.forEach((key)=>{
        let found = false;
        tempData.filter((item)=>{
          if(!found && item.page_name === key) {
              data.push(item);
              found = true;
              return false;
          } else 
              return true;
        })
      })
    }
    return data;
  }
  async componentDidUpdate() {
    if (this.state.loading === true) {
      const data = await this.handleLoadData();
      this.setState({loading: false, data, propData: this.props.navData});
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (JSON.stringify(nextProps.navData) !== JSON.stringify(prevState.propData)) {
      return {loading: true};
    }
    return null;
  }
  handleRenderBread=(data)=>{
    const {classes, currentPage} = this.props;
    const returnValue = [];
    returnValue.push((
      <StyledBreadcrumb
        key={'/'}
        className={`breadcrumb-item`}
        component={LinkDuo}
        to={'/'}
        label={"Home"}
      />
    ));
    returnValue.push(<li className={classes.seperator}>/</li>)
    for(let i = 0; i < data.length;i++){
      returnValue.push((
        <StyledBreadcrumb
          key={`/${data[i].url_link}`}
          className={`breadcrumb-item`}
          component={LinkDuo}
          to={`/${data[i].url_link}`}
          label={data[i].page_title}
        />
      ));
      returnValue.push(<li className={classes.seperator}>/</li>)
    }
    returnValue.push((
      <StyledBreadcrumb
        key={`null`}
        component={'div'}
        label={currentPage}
      />
    ))
    return returnValue;
  }
  render(){
    const {classes} = this.props;
    const {data} = this.state;
    return (
      <nav className={classes.root} aria-label="breadcrumb">
        <ol className={`${classes.breadcrumbs} breadcrumb-component`}>
          {
            this.state.loading ? (
              <React.Fragment>
                <li className={classes.filler}></li>
                <li style={{zIndex: 1}}>/</li>
                <li className={classes.filler}></li>
                <li style={{zIndex: 1}}>/</li>
                <li className={classes.filler}></li>
              </React.Fragment>
            ) : (
              this.handleRenderBread(data)
            )
          }
        </ol>
      </nav>
    );
  }
}

BreadCrumbs.propTypes = {
  classes: PropTypes.object.isRequired
};
BreadCrumbs.defaultProps={
  navData: [],
  currentPage: ""
}
export default connect(
  state => ({db: state.db}),
  dispatch => bindActionCreators({...dbCreators}, dispatch)
)(withStyles(styles)(BreadCrumbs));